import * as http from 'utils/http';
import config from 'config';
import { urlToId } from 'utils/converters';
import { GIS_HEADERS } from 'tenant/bussines';

const getDriverWithUserId = async (user_id) => {
  const user = await http.get(`${config.API_URL}users/${user_id}`);
  const driver = await http.get(user.driver);
  return {
    ...driver,
    carrier_id: urlToId(driver.carrier),
  };
};

const getDriver = async (driver_id) => {
  const driver = await http.get(`${config.API_URL}mercury/drivers/${driver_id}/`);
  return driver;
};

const getGPSNow = async () => {
  const positions = await http.get(`${config.GEO_URL}gps/now`, null, GIS_HEADERS);
  return (positions || {}).data || [];
};

export { getDriverWithUserId, getGPSNow, getDriver };
